import {Injectable} from '@angular/core';
import * as Actions from './auth.actions';
import {BaseState} from '../../base.state';
import * as fromAuth from './';
import {select} from '@ngrx/store';
import {filter} from 'rxjs/operators';

@Injectable()
export class AuthState extends BaseState {

    get token(){
        return this._store.pipe(
            select(fromAuth.getToken)
        );
    }

    get isLoggedIn() {
        return this._store.pipe(
            select(fromAuth.getLoggedIn),
            filter(val => val !== undefined)
        );
    }

    get didSucceed() {
        return this._store.pipe(
            select(fromAuth.getDidSucceed),
            filter(val => val !== undefined)
        );
    }

    get profile(){
        return this._store.pipe(
            select(fromAuth.getProfile),
            filter(val => val !== undefined)
        );
    }

    login(credentials) {
        this._store.dispatch(new Actions.Login(credentials));
        return this.didSucceed;
    }

    check(token) {
        this._store.dispatch(new Actions.CheckAuth(token));
        return this.didSucceed;
    }

    logout() {
        this._store.dispatch(new Actions.Logout({}));
        this.clearStatus()
    }

    set(i){
        this._store.dispatch(new Actions.Set(i))
    }

    clearStatus() {
        this._store.dispatch(new Actions.Set({success: undefined}));
    }

}
